import { CONTACT_POINT_SYSTEM, REGEX_EXPS } from "utils/constants";
import * as yup from "yup";

const validation = (errors, options = {}) => {
  const { franceAddressZipCodeCity: validateZipCode } = options;
  return yup.object().shape({
    telecoms: yup.object().shape({
      [CONTACT_POINT_SYSTEM.ZIP_CODE]: yup.object().shape({
        value: validateZipCode
          ? yup
              .string()
              .typeError(errors.REQUIRED)
              .required(errors.REQUIRED)
              .test("isValid", errors.INVALID_VALUE, async function (value) {
                const isValidRegex = new RegExp(REGEX_EXPS.zipCode).test(value);
                if (!isValidRegex) return false;
                const {
                  data: {
                    franceAddressZipCodeCity: { response },
                  },
                } = await validateZipCode({
                  variables: {
                    where: { zipCode: value },
                  },
                });
                return !!response.length;
              })
          : yup
              .string()
              .typeError(errors.REQUIRED)
              .required(errors.REQUIRED)
              .matches(REGEX_EXPS.zipCode, {
                message: errors.INVALID_VALUE,
                excludeEmptyString: true,
              }),
      }),
    }),
    birthDate: yup.date().typeError(errors.REQUIRED).required(errors.REQUIRED),
    socialRegime: yup
      .string()
      .typeError(errors.REQUIRED)
      .required(errors.REQUIRED),
    issuanceDate: yup
      .date()
      .typeError(errors.REQUIRED)
      .required(errors.REQUIRED),
    optMadelin: yup.boolean().nullable(),
  });
};

export default validation;
